// src/admin/DevDashboard.jsx
import React, { useEffect, useState, useMemo } from "react";
import api from "../api/axiosClient";
import { useAuth } from "../context/AuthContext";
import "../style/devDashboard.css";

export default function DevDashboard() {
  const { user, role } = useAuth();

  // 🔥 FIX REAL (correcto según tu AuthContext)
  const isDev = role === "desarrollador";

  const [instituciones, setInstituciones] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* =====================================================
     📡 CARGAR INSTITUCIONES
  ===================================================== */
  useEffect(() => {
    const cargarInstituciones = async () => {
      if (!isDev) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const res = await api.get("/instituciones/listar");

        const data = res.data?.instituciones || [];
        setInstituciones(data);
      } catch (err) {
        console.error("❌ Error cargando instituciones:", err);

        setError(
          err.response?.data?.msg ||
          "Error al cargar instituciones"
        );
      } finally {
        setLoading(false);
      }
    };

    cargarInstituciones();
  }, [isDev]);

  /* =====================================================
     🔍 FILTRO INTELIGENTE
  ===================================================== */
  const filtradas = useMemo(() => {
    const texto = busqueda.toLowerCase();

    return instituciones.filter((i) =>
      i.nombre?.toLowerCase().includes(texto) ||
      String(i.tenant_id || "").includes(texto) ||
      i.municipio?.toLowerCase().includes(texto) ||
      i.rector?.toLowerCase().includes(texto)
    );
  }, [busqueda, instituciones]);

  /* =====================================================
     🔐 BLOQUEO POR ROL
  ===================================================== */
  if (!isDev) {
    return (
      <div className="alerta-error">
        ❌ No tienes permiso para acceder a este módulo
      </div>
    );
  }

  /* =====================================================
     🧠 RENDER
  ===================================================== */
  return (
    <div className="dev-dashboard">
      <div className="dashboard-header">
        <h2>🛠️ Panel del Desarrollador</h2>
        <p>Gestión global de instituciones (Tenants)</p>
      </div>

      <div className="dashboard-actions">
        <input
          type="text"
          placeholder="🔍 Buscar institución, tenant, rector o municipio..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      {loading && <p className="loading">⏳ Cargando instituciones...</p>}

      {error && <p className="error">{error}</p>}

      {!loading && !error && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Institución</th>
                <th>Tenant ID</th>
                <th>Municipio</th>
                <th>Rector</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>
              {filtradas.map((i) => (
                <tr key={i.id}>
                  <td>{i.id}</td>
                  <td className="nombre">{i.nombre || "—"}</td>
                  <td>{i.tenant_id}</td>
                  <td>{i.municipio || "—"}</td>
                  <td>{i.rector || "—"}</td>
                  <td>
                    <span
                      className={
                        i.activo === 1
                          ? "estado activo"
                          : "estado inactivo"
                      }
                    >
                      {i.activo === 1 ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                </tr>
              ))}

              {!filtradas.length && (
                <tr>
                  <td colSpan="6" className="no-data">
                    No se encontraron instituciones
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
